/**
 * Entry point for development and production PWA builds.
 */
import 'regenerator-runtime/runtime';
import { createRoot } from 'react-dom/client';
import App from './App';
import React from 'react';

/**
 * EXTENSIONS AND MODES
 * =================
 * pluginImports.js is dynamically generated from extension and mode
 * configuration at build time.
 *
 * pluginImports.js imports all of the modes and extensions and adds them
 * to the window for processing.
 */
import { modes as defaultModes, extensions as defaultExtensions } from './pluginImports';
import loadDynamicConfig from './loadDynamicConfig';
export { history } from './utils/history';
export { preserveQueryParameters, preserveQueryStrings } from './utils/preserveQueryParameters';

loadDynamicConfig(window.config).then(config_json => {
  // Reset Dynamic config if defined
  if (config_json !== null) {
    window.config = config_json;
  }

  /**
   * Combine our appConfiguration with installed extensions and modes.
   * In the future appConfiguration may contain modes added at runtime.
   *  */
  const appProps = {
    config: window ? window.config : {},
    defaultExtensions,
    defaultModes,
  };

  const container = document.getElementById('root');

  const root = createRoot(container);
  root.render(React.createElement(App, appProps));

  // Astra DICOM fast cache: a narrow service worker that serves WADO pixel
  // data cache-first (DICOM instances are immutable), so scrolling/re-opens/
  // reloads skip the PACS round-trip entirely. QIDO + metadata stay live.
  // Disable with `enableDicomCache: false` in the app config.
  if ('serviceWorker' in navigator && window.config?.enableDicomCache !== false) {
    const publicUrl = process.env.PUBLIC_URL || '/';
    navigator.serviceWorker
      .register(`${publicUrl}dicom-cache-sw.js`)
      .catch(err => console.warn('DICOM cache service worker not registered:', err));
  }
});
